<div class="columns is-multiline pl-2 pr-2 is-vcentered">
  <div class="column is-3">
    <mat-form-field class="full-width">
      <mat-label>{{ 'claimSearchForm.searchBy.label' | localize }}</mat-label>
      <mat-select [formControl]="propertyNameFormControl">
        @for (prop of propertyNameValueOptions; track prop.value) {
          <mat-option [value]="prop.value">{{ prop.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="column">
    <mat-form-field class="full-width">
      <mat-label>{{ propertyName.name }}</mat-label>
      <input type="text"
             placeholder="{{ 'claimSearchForm.searchValue.placeholder' | localize }}"
             aria-label="{{ propertyName.name }}"
             matInput
             [formControl]="propertyValueFormControl"
             [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        @for (option of filteredPropertyValueOptions; track option) {
          <mat-option value="{{option}}">{{ option }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="column is-2">
    <div class="pb-5">
      <button class="button is-dark full-width" [disabled]="!isPropertyNameValid || !isPropertyValueValid"
              (click)="search()">
        <span class="icon">
          <i class="fa-solid fa-magnifying-glass"></i>
        </span>
        <span>{{ 'claimSearchForm.search.label' | localize }}</span>
      </button>
    </div>
  </div>
  <div class="column is-2">
    <div class="pb-5">
      <button class="button is-dark full-width" (click)="cancelSearch()">
        <span class="icon">
          <i class="fa-solid fa-xmark"></i>
        </span>
        <span>{{ 'claimSearchForm.cancelSearch.label' | localize }}</span>
      </button>
    </div>
  </div>

</div>
